module.exports = "<div class=\"results-item\" style=\"min-height:auto; padding-top:18px\">\r\n        <p style=\"font-size:18px\"><span style=\"color:#dd4b39\">Did you mean:</span> <strong><em><a style=\"cursor: pointer\" id=\"spelling-correction\">{{Model.Title}}</a></em></strong></p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/correction-result.html
// module id = 407
// module chunks = 1